export default __webpack_public_path__ + "static/media/Logo.3f553483.svg";